<template>
  <div :data-extra="module.extra ? module.index : null">
    <div class="ctrlModule" :title="module.extra ? `${module.type} / ${module.index}` : `${module.type} / ${module.index} / ${module.location}`">
      <div class="spec">
        <span v-if="!module.extra" class="specItem index" >{{module.index}}: {{module.location}}</span>
        <span v-if="module.extra && module.index === 'all'" class="specItem">{{module.type}} all</span>
        <span v-if="module.extra && module.index === 'multi'" class="specItem">{{module.type}} multi<i v-if="module.multi.length"> (+{{module.multi.length}})</i></span>
      </div>
      <!-- fcu:: fanspeed -->
      <div v-if="module.detail.type === 'fcu' && module.detail.control === 'speed'" class="detail">
        <div class="fanSpeed">
          <div class="speed">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
          </div>
          <div class="btns">
            <button type="button" class="btnMinus">-</button>
            <button type="button" class="btnPlus">+</button>
            <button type="button">STOP</button>
            <button type="button">AUTO</button>
          </div>
        </div>
      </div>
      <!-- //fcu:: fanspeed -->
      <!-- fcu:: temp -->
      <div v-else-if="module.detail.type === 'fcu' && module.detail.control === 'temp'" class="detail">
        <div class="temp">
          <span class="current">26.0</span><span class="set">/25.0</span>
        </div>
      </div>
      <!-- //fcu:: temp -->
      <div v-else class="detail">
        <div class="icon"><img :src="icon(module.detail)" alt="" /></div>
        <div class="label">
          <input type="text" class="input" v-model="label">
        </div>
        <!-- curtain -->
        <div v-if="module.type === 'curtain'" class="btnControl">
          <button type="button" class="btnCurtain">OPEN</button>
          <button type="button" class="btnCurtain">CLOSE</button>
          <button v-if="module.detail.stop" type="button" class="btnCurtain">STOP</button>
        </div>
        <!-- //curtain -->
        <!-- door -->
        <div v-else-if="module.type === 'door'" class="btnControl">
          <button type="button" class="btnCurtain">OPEN</button>
        </div>
        <!-- //door -->
        <!-- etc -->
        <div v-else class="btnControl"><button type="button" class="toggle"></button></div>
        <!-- //etc -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'module',
    'controlList'
  ],
  computed: {
    label: {
      get () {
        const lang = this.lang
        return this.module.label[lang]
      },
      set (label) {
        const id = this.module.id
        this.$emit('updateLabel', { id: id, label: label })
      }
    },
    isValidType () {
      return this.types.includes(this.module.type)
    }
  },
  data () {
    return {
      types: [
        'light',
        'fcu',
        'dm',
        'curtain',
        'door'
      ]
    }
  },
  methods: {
    disabled (data) {
      const key = Object.keys(data)[0]
      const val = Object.values(data)[0]
      const controlList = this.controlList
      const isDisabled = !controlList[key].includes(val)
      return isDisabled
    },
    icon (detail) {
      const isValidType = this.isValidType
      const src = isValidType ? detail.icon : 'default'
      const icon = require(`@/assets/img/roomcontroller/ico_${src}.png`)
      return icon
    }
  }
}
</script>
